import PageHeader from "app/shared/PageHeader";
import "../../Integrations.scss";

import { Badge, Button, Empty, Modal, Segmented, Spin, Tabs, Tag, message } from "antd";
import Typography from "app/shared/Typography";
import { colorPicker } from "app/utils/color.helper";
import { apiPut } from "app/services/apiServices";
import axios from "axios";
import {
  PlusOutlined,
  EditOutlined,
  LoadingOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
import EmptyState from "app/shared/EmptyState";
import { forwardRef, useRef, useState } from "react";
import AddIntegration from "../AddIntegration";
import { AgTableClient } from "app/shared/AgTable";
import AddBusiness from "app/scenes/Onboarding/components/AddBusiness";
import ValidateCredentials from "app/scenes/Onboarding/components/ValidateCredentials";
import GSTCredentials from "app/scenes/Credentials/components/GSTCredentials";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { userInfo } from "app/config/States/users";
import { Mixpanel } from "app/config/Mixpanel";
import { API_ENDPOINT_GST_CREDENTIAL_UPDATE } from "app/scenes/Credentials/credentials.constants";

const initialColDefs = [
  {
    field: "pan",
    headerName: "PAN",
    enableRowGroup: true,
    minWidth: 200,
  },
  {
    field: "gstin",
    headerName: "GSTIN",
    enableRowGroup: true,
    minWidth: 200,
  },
  {
    field: "username",
    headerName: "Username",
    enableRowGroup: true,
    minWidth: 200,
    editable: true,
  },

  {
    field: "password",
    headerName: "Password",
    enableRowGroup: true,
    minWidth: 200,
    editable: true,
  },
];

const tagColorMap: any = {
  INVALID: "red",
  ACTIVE: "green",
  PENDING: "orange",
};

const GSTIntegration = forwardRef((props: any, ref: any) => {
  const gridRef = useRef<any>(null);
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState("Temp View");
  const [userDetails, setUserDetails] = useRecoilState<any>(userInfo);
  const [integrationType, setIntegrationType] = useState("SINGLE");
  const [bulkIntegrationData, setBulkIntegrationData] = useState(null);
  const [showBulkValidate, setShowBulkValidate] = useState(false);
  const [cardData, setCardData] = useState<any>(null);
  const [editMode, setEditMode] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const gstGridRef: any = useRef();
  const navigate = useNavigate();
  const [isBulkModalVisible, setIsBulkModalVisible] = useState(false);
 
  const handleSuccess = () => {
    setShowModal(false);
    props.loadData();
  };

  Mixpanel.track("User Landed On GST Integration Page", {
    Screen: "Integration",
  });
  const handleBulkSuccess = () => {
    setShowBulkValidate(false);
    setShowModal(false);
    setBulkIntegrationData(null);
    setIntegrationType("SINGLE");
    props.loadData && props.loadData();
  };

  

  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <div
        style={{
          //padding: "12px 20px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        {/* {userDetails?.email.includes("kgrp.in") ||
          userDetails?.email.includes("finkraft.ai") ? (
          <Segmented
            options={["Temp View", "Main View"]}
            onChange={(value) => setActiveTab(value)}
          />
        ) : (
          <div />
        )} */}
        {/* <div>
          <Button
            type="primary"
            size="small"
            icon={<DownloadOutlined />}
            onClick={() => {
              gstGridRef.current && gstGridRef.current?.handleExportTableData();
              Mixpanel.track("User Downloaded GST Credentials", {
                Screen: "Integration",
              });
            }}
            style={{ marginRight: 24 }}
          >
            Download Credentials
          </Button>
          <Button
            type="primary"
            size="small"
            icon={<PlusOutlined />}
            onClick={() => {
              navigate("/credential/gst/add/review/final");
            }}
            style={{ marginRight: 24 }}
          >
            Add Credentials
          </Button>
        </div> */}

      </div>
      {activeTab === "Tile" ? (
        <div className="CardList">
          <div
            className="IntegrationCard cardAdd"
            onClick={() => {
              setCardData(null);
              setShowModal(true);
            }}
          >
            <PlusOutlined
              style={{ fontSize: 44, color: colorPicker("neutral.700") }}
            />
          </div>

          {props.data.map((creds: any, key: any) => {
            return (
              <div
                className="IntegrationCard"
                key={key}
                onClick={() => {
                  setCardData(creds);
                  setShowModal(true);
                  setEditMode(true);
                }}
              >
                <div className="CardTopContainer">
                  <div className="ImageContainer">
                    <img
                      src="https://miro.medium.com/v2/resize:fit:1400/1*9mkbjH3YUUGDSWk2UXFghw.png"
                      alt="integrationImg"
                    />
                  </div>
                  <Tag color={tagColorMap[creds.status]}>
                    {creds.status === "PENDING" ? (
                      <Spin
                        style={{ marginRight: 6 }}
                        indicator={
                          <LoadingOutlined
                            style={{ fontSize: 14, color: "#d46b08" }}
                            spin
                          />
                        }
                      />
                    ) : null}
                    {creds.status === "PENDING" ? "Processing" : creds.status}
                  </Tag>
                  {/* <Tag color={tagColorMap[creds.status]}>{creds.status}</Tag> */}
                </div>
                <div className="CardDescription">
                  <Typography
                    variant="h6"
                    style={{ color: colorPicker("neutral.800") }}
                  >
                    {creds?.username || creds?.gstin}{" "}
                    {creds.status !== "ACTIVE" ? (
                      <Badge dot>
                        {creds.username ? (
                          <EditOutlined />
                        ) : (
                          <PlusOutlined
                            style={{
                              fontSize: 20,
                              color: colorPicker("neutral.700"),
                            }}
                          />
                        )}
                      </Badge>
                    ) : null}
                  </Typography>

                  <Typography
                    variant="xs"
                    style={{ color: colorPicker("neutral.700") }}
                  >
                    Fast and reliable approach for reconcilation
                  </Typography>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div style={{ flex: 1 }}>
          {/* <AgTableClient
            //@ts-ignore
            rowData={props.data}
            columnDefs={initialColDefs}
            autoResize
          /> */}
          <GSTCredentials ref={gstGridRef} componentType type={activeTab} />
        </div>
      )}
      <Modal
        title="GST Portal Integration"
        open={showModal}
        onCancel={() => setShowModal(false)}
        footer={false}
        width={integrationType === "SINGLE" ? 500 : 1000}
      >
        {integrationType === "SINGLE" ? (
          <AddIntegration
            onSuccess={handleSuccess}
            type="GST"
            showBulk={() => setIntegrationType("BULK")}
            data={cardData}
            editMode={cardData && cardData?.username !== null ? true : false}
          />
        ) : bulkIntegrationData === null ? (
          <AddBusiness
            goNext={(gstinData: any) => setBulkIntegrationData(gstinData)}
            goBack={() => setIntegrationType("SINGLE")}
          />
        ) : (
          <div style={{ height: 400 }}>
            {bulkIntegrationData && (
              <ValidateCredentials
                tableData={bulkIntegrationData}
                onSuccess={handleBulkSuccess}
              />
            )}
          </div>
        )}
      </Modal>


    </div>
  );
});

export default GSTIntegration;
